//Live Toasts
export const LIVE_TOAST = [
  {
    text: "Use the ",
    code: ".hide",
  },
  {
    text: "class through hide toast and <code>.show </code>class through visible toast and given directions.",
    code: "[top-0/bottom-0/start-0/end-0]",
  },
];

//Colors Schemes
export const COLORS_SCHEMES = [
  {
    text: "Use the ",
    code: ".hide",
  },
  {
    text: ".show ",
    code: "class through visible toast.",
  },
];

//Stacking Toast
export const STACKING_TOAST = [
  {
    text: "You can stack toasts by wrapping them in a toast container, which will vertically add some spacing. ",
    code: "[toast-*]",
  },
  {
    text: "through change icons colors.",
  },
];

export const STACKING_TOAST_LIST = [
  {
    bell: true,
    iconColor: "warning",
    title: "Roxo theme",
    time: "2 sec ago",
    bodyText: "Hello, I'm a UX-designer.",
  },
  {
    bell: true,
    iconColor: "danger",
    title: "Zeta theme",
    time: "6 min ago",
    bodyText: "Hello, I'm a Software developer.",
  },
  {
    bell: true,
    iconColor: "success",
    title: "Voxo theme",
    time: "3 sec ago",
    bodyText: "Hello, I'm a professional web-designer.",
  },
];

//Translucent Toast
export const TRANSLUCENT_TOAST = [
  {
    text: " Use the ",
    code: ".hide ",
  },
  {
    text: "class through hide toast and ",
    code: ".show ",
  },
  {
    text: "class through visible toast and given directions.",
    code: "[toast-*]",
  },
  {
    text: "through change icons colors.",
  },
];

export const TRANSLUCENT_TOAST_LIST = [
  {
    iconColor: "dark",
    title: "Koho theme",
    time: "1 sec ago",
    bodyText: " Hello, I'm a full-stack developer.",
  },
  {
    iconColor: "secondary",
    title: "Fastkart theme",
    time: "just now",
    bodyText: " Hello, I'm a UX-designer.",
  },
  {
    iconColor: "success",
    title: "Oslo theme",
    time: "44 min ago",
    bodyText: "Hello, I'm a professional web-designer.",
  },
];

//Default Toasts
export const DEFAULT_TOAST = [
  {
    text: " Use the ",
    code: ".hide ",
  },
  {
    text: "class through hide toast and ",
    code: ".show ",
  },
  {
    text: "class through visible toast.",
  },
];

//Unique Toasts
export const UNIQUE_TOAST = [
  {
    text: " Use the ",
    code: ".hide ",
  },
  {
    text: "class through hide toast and ",
    code: ".show ",
  },
  {
    text: "class through visible toast.",
  },
];

//Toast Placements
export const PLACEMENT_TOAST = [
  {
    text: " Use the ",
    code: ".hide ",
  },
  {
    text: "class through hide toast and ",
    code: ".show ",
  },
  {
    text: "class through visible toast.",
    code: ".form-select",
  },
  {
    text: " through select any positions.",
  },
];

export const PLACEMENT_LIST = [
  {
    text: "Top left",
    className: "top-0 start-0",
  },
  {
    text: "Top center",
    className: "top-0 start-50 translate-middle-x",
  },
  {
    text: "Top right",
    className: "top-0 end-0",
  },
  {
    text: "Middle left",
    className: "top-50 start-0 translate-middle-y",
  },
  {
    text: "Middle center",
    className: "top-50 start-50 translate-middle",
  },
  {
    text: "Middle right",
    className: "top-50 end-0 translate-middle-y",
  },
  {
    text: "Bottom left",
    className: "bottom-0 start-0",
  },
  {
    text: "Bottom center",
    className: "bottom-0 start-50 translate-middle-x",
  },
  {
    text: "Bottom right",
    className: "bottom-0 end-0",
  },
];
